export default {
  downloadPlanJson: 'Download Plan JSON',
  downloadModelJson: 'Download Model JSON',
  preparingPlanDownload: 'Preparing your plan data for download...',
  preparingModelDownload: 'Preparing your model data for download...',
  tryAgain: 'Try Again',
  planDownloadSuccess: 'Your plan data has been downloaded successfully!',
  modelDownloadSuccess: 'Your model data has been downloaded successfully!',
  closeTabMessage: 'You can close this tab now.',
  readyToDownloadPlan: 'Ready to download your plan JSON.',
  readyToDownloadModel: 'Ready to download your model JSON.',
  downloadModelPklFiles: 'Download Model PKL Files',
  loadingPklInfo: 'Loading PKL file information...',
  pklFilesDescription: 'Download the PKL files associated with this model:',
  downloadModelPkl: 'Download Model PKL',
  modelPklNotAvailable: 'Model PKL file not available',
  downloadPlanPkl: 'Download Plan PKL',
  planPklNotAvailable: 'Plan PKL file not available',
  noPklFilesAvailable: 'No PKL files available for this model.',
  pklReasonUnauthorized: 'Your account does not have permission to read model files. Only Scientists and Admins can download PKL files.',
  pklReasonNotFound: 'The file was not found in storage at {path}.',
  pklReasonUnknown: 'Storage returned an error: {error}',
  pklReasonNoPath: 'The storage location for this PKL file could not be determined from the model data.',
  deletedPlanTitle: 'This plan was deleted',
  deletedPlanExplanation: 'Showing the copy saved when the plan was sent to run. It contains the plan inputs only, without results.',
  deletedPlanQueuedOn: 'Copy saved on {date}',
  deletedModelTitle: 'This model was deleted',
  deletedModelExplanation: 'Showing the model as it was when it was deleted, kept in the trash until it is purged. Its PKL files and plans remain available until then.',
  deletedModelDeletedOn: 'Deleted on {date}',
  deletedModelDeletedOnBy: 'Deleted on {date} by {name}',
  deletedModelPurgeOn: 'It will be purged on {date}',
  modelNotFound: 'Model not found. It may have been deleted more than 7 days ago.',
  planNotFound: 'Plan not found.',
  permissionDenied: 'Your account does not have permission to export this data. Only Scientists and Admins can.',
  openModelOverview: 'Open Model Overview',
  openModelError: 'Could not open this model. Your account may not have access to it.',
  authenticationRequired: 'Authentication required. Please log in to download data.',
  noDataFound: 'No data found for the specified ID(s)',
  exportError: 'An error occurred while exporting data'
}
